/* eslint-disable max-len */

/* eslint-disable react/react-in-jsx-scope */
import
React,
{ useMemo } from 'react';
import { Button } from 'reactstrap';
import { useHistory } from 'react-router-dom';

// const PhotoFormatter = (value) => (
//   <div className="products-list__img-wrap">
//     <img src={value} alt="" />
//   </div>
// );
const topicEdit = (history, info) => {
  history.push({
    pathname: `/admin/curriculum-edit/${info.id}`,
    state: { data: info },
  });
};

const materialDetail = (history, info) => {
  history.push({
    pathname: `/admin/course-material/${info.id}`,
    search: '?tabs=1',
    state: { data: info },
  });
};

const ListDataTopic = (dataAPI) => {
  const history = useHistory();
  const columns = useMemo(
    () => [
      {
        Header: 'No',
        accessor: 'number',
        width: 20,
        disableSortBy: true,
      },
      {
        Header: 'Title',
        accessor: 'title',
        disableSortBy: true,
        width: 110,
      },
      {
        Header: 'Material',
        accessor: 'material_list',
        disableSortBy: true,
        width: 110,
      },
      {
        Header: 'Quiz',
        accessor: 'quiz_list',
        disableSortBy: true,
        width: 110,
      },
      {
        Header: 'Action',
        accessor: 'action',
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 110,
      },
    ], [],
  );

  const data = [];
  const rows = () => {
    for (let i = 0; i < dataAPI.length; i += 1) {
      data.push({
        id: dataAPI[i].id,
        number: `${dataAPI[i]?.order}`,
        title: dataAPI[i]?.title,
        material_list: `${dataAPI[i]?.total_material ?? '0'}`,
        quiz_list: `${dataAPI[i]?.total_quiz ?? '0'}`,
        action: [
          // eslint-disable-next-line no-loop-func
          // eslint-disable-next-line max-len
          (<Button key={dataAPI[i].id} color="outline-success" onClick={() => topicEdit(history, dataAPI[i])}>Detail</Button>),
          (<Button key={i} color="outline-success" onClick={() => materialDetail(history, dataAPI[i])}>Material</Button>),
        ],
      });
    }
  };

  rows();
  const partnerListTableData = { tableHeaderData: columns, tableRowsData: data };
  return partnerListTableData;
};

export default ListDataTopic;
